import { Checkbox as CheckboxAnt } from 'antd'
import { Field, FieldProps } from 'formik'
import { CheckboxProps as $CheckboxProps } from 'antd/lib/checkbox/Checkbox'
import { FormikFieldProps } from './FieldProps'

export type CheckboxProps = FormikFieldProps & $CheckboxProps

export const Checkbox = ({ name, validate, checked, disabled, ...restProps }: CheckboxProps): JSX.Element => (
  <Field name={name} validate={validate}>
    {({ field: { value }, form: { setFieldValue } }: FieldProps) => (
      <CheckboxAnt
        name={name}
        checked={!disabled ? value : checked}
        onChange={(v) => {
          setFieldValue(name, v.target.checked)
        }}
        disabled={disabled}
        {...restProps}
      />
    )}
  </Field>
)
